export enum LogoColor {
  Gold = `a-logo__tallow`,
  Light = `a-logo__white`,
  Dark = `a-logo__ragoon`,
}

export interface LogoProps {
  color?: LogoColor;
}
